export const responsibilitiesData = [
    "Изготвяне и осчетоводяване на първични и вторични документи",
    "Осчетоводяване на ведомости за заплати",
    "Осчетоводяване на банкови и касови операции",  
    "Водене на складови наличности",  
    "Изготвяне на валутни отчети",  
    "Анализ и контрол на разчети",  
    "Поддържане на кореспонденция с клиенти и доставчици",     
    "Отчитане на строителни проекти", 
    "Изготвяне на ДДС декларации",
    "Участие в изготвяне на ГФО и ГДД",
    "Електронна комуникация",  
    "Работа със счетоводен софтуер и вътрешни системи"
];